import { useDispatch, useSelector } from "react-redux";

import { forgetPassword } from "../services/passwordApi";
import { setIsLoading } from "../slices/passwordSlice";
import { message } from "antd";
import { useTranslation } from "react-i18next";

function useForgotPassword() {
  const isLoading = useSelector((state) => state.password.isLoading);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const doForgotPassword = async (values) => {
    try {
      dispatch(setIsLoading(true));
      await forgetPassword(values);
      message.success(t("common.success"))
      dispatch(setIsLoading(true));
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const onCancel = () => {
    window.history.back();
  };

  return { isLoading, doForgotPassword, onCancel };
}

export default useForgotPassword;
